import React, { createContext, useState, useEffect } from 'react';
import { readGames, readPlayers } from './parseData'; // Replace with the correct path

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [gamesData, setGamesData] = useState(null);
  const [playersData, setPlayersData] = useState(null);
  const [loading, setLoading] = useState(true); // New loading state

  useEffect(() => {
    const fetchData = async () => {
      try {
        const games = await readGames();
        const players = await readPlayers();
        setGamesData(games);
        setPlayersData(players);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // Set loading to false after data is fetched
      }
    };

    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{ gamesData, playersData, loading }}>
      {children}
    </DataContext.Provider>
  );
};
